import { apiFactory } from "generated";
import axiosInstance from "./axiosInstance";

export const eventVariableClient = apiFactory.getEventsInstance(axiosInstance);
